module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0026.jpg?v=958a7a60";